<div>
  <app-navigation-bar></app-navigation-bar>
  <ngx-spinner id="spinnerUpload" bdColor="rgba(51, 51, 51, 0.3)" size="medium" color="#fff" type="ball-scale-multiple" ></ngx-spinner>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>